export type ActivityResource = {
id: number;
log_name: string | null;
description: string;
event: string | null;
subject_type: string | null;
subject_id: number | null;
causer_type: string | null;
causer_id: number | null;
batch_uuid: string | null;
properties_original: Array<any>;
properties_changes: Array<any>;
created_at: string;
updated_at: string;
user?: UserResource;
};
export type AddressResource = {
id: number;
customer_id: number;
address_type: AddressTypeEnum;
address_type_label: string | null;
label: string;
company: string | null;
firstname: string;
lastname: string;
address1: string;
address2: string | null;
zipcode: string;
city: string;
phone: string | null;
is_default: boolean;
created_at: string;
updated_at: string;
country?: CountryResource;
country_state?: CountryStateResource;
customer?: CustomerResource;
country_name?: string;
country_iso_code?: string;
country_state_name?: string;
country_state_iso_code?: string;
delivery_subscriptions_count?: number;
billing_subscriptions_count?: number;
};
export type AddressSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
is_default: number | null;
};
export enum AddressTypeEnum { PERSONAL = 0, PROFESSIONAL = 1, POSTAL_BOX = 2 };
export type AdminResource = {
id: number;
label: string;
firstname: string;
lastname: string;
email: string;
email_verified_at: string | null;
is_active: boolean;
created_at: string;
updated_at: string;
};
export type AdminSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
is_active: number | null;
};
export type BlockResource = {
id: number;
blockable_id: number | null;
blockable_type: string | null;
title: string | null;
title_translations?: Record<string, string>;
subtitle: string | null;
subtitle_translations?: Record<string, string>;
content: string | null;
content_translations?: Record<string, string>;
cta_text: string | null;
cta_text_translations?: Record<string, string>;
cta_url: string | null;
cta_url_translations?: Record<string, string>;
cta_target: LinkTargetEnum | null;
type: BlockTypeEnum;
type_label: string | null;
medias?: Array<MediaResource>;
product?: ProductResource;
subscription_plan?: SubscriptionPlanResource;
created_at: string;
updated_at: string;
};
export enum BlockTypeEnum { DEFAULT = 0, HEADER = 1, REINSURANCE = 2, FOOTER = 3, PRODUCT_SLIDER = 4, NEWSLETTER = 5, FEATURED_CATEGORY = 6, FAQ = 7, HISTORY = 8, HOW_DOES_THAT_WORK = 9, PRESENTATION = 10, COLLECTION_TEASER = 11, IMAGE_SLIDER_WITH_CARD = 12, HERO_IMAGE = 14, SUBSCRIPTION_PLAN = 15, POST_MAGAZINE = 16, POST_MAGAZINE_TECHNICAL_SHEET = 17, POST_MAGAZINE_HIGHLIGHT = 18, REASONS_TO_SUBSCRIBE = 19, VIDEO_SLIDER = 20, IMAGE_SLIDER_WITH_THUMBNAILS = 21, PRODUCT_DESCRIPTION = 22, SPECIFICATIONS_FEATURES = 23, POST_ASSEMBLY_GUIDE_KIT = 24, POST_ASSEMBLY_GUIDE_STEP = 25, PRODUCT_SLIDER_DESCRIPTION = 26, POST_ASSEMBLY_GUIDE_PART = 27 };
export type CarrierAddressTypeResource = {
carrier_id: number;
address_type: AddressTypeEnum;
address_type_label: string | null;
created_at: string;
updated_at: string;
};
export type CarrierRangeResource = {
id: number;
range_min: number;
range_max: number;
created_at: string;
updated_at: string;
shipping_zones?: Array<ShippingZoneResource>;
};
export enum CarrierRangeRuleEnum { DEACTIVATE = 0, ACTIVATE = 1 };
export type CarrierRangeShippingZoneResource = {
carrier_range_id: number;
shipping_zone_id: number;
price_incl_tax: number;
created_at: string;
updated_at: string;
};
export enum CarrierRangeTypeEnum { TOTAL_PRICE = 0, TOTAL_WEIGHT = 1 };
export type CarrierResource = {
id: number;
label: string;
name: string;
description: string | null;
description_translations?: Record<string, string>;
url: string | null;
image: string | null;
wms_code: string | null;
range_type: CarrierRangeTypeEnum;
range_rule: CarrierRangeRuleEnum;
order_column: number;
is_active: boolean;
created_at: string;
updated_at: string;
carrier_tax_rate?: number;
shipping_price_excl_tax?: number;
shipping_price_tax?: number;
shipping_price_incl_tax?: number;
tax?: TaxResource;
carrier_ranges?: Array<CarrierRangeResource>;
carrier_address_types?: Array<CarrierAddressTypeResource>;
customer_groups?: Array<CustomerGroupResource>;
medias?: Array<MediaResource>;
};
export type CarrierSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
is_active: number | null;
};
export type CartDiscountResource = {
id: number;
cart_id: number;
cart_line_id: number | null;
discount_id: number;
amount_discounted_excl_tax: number;
amount_discounted_tax: number;
amount_discounted_incl_tax: number;
created_at: string;
updated_at: string;
cart?: CartResource;
cart_line?: CartLineResource;
discount?: DiscountResource;
};
export type CartLineResource = {
id: number;
label: string;
customization_text: string | null;
quantity: number;
price_excl_tax: number;
price_tax: number;
price_incl_tax: number;
tax_rate: number;
discounts_excl_tax: number;
discounts_tax: number;
discounts_incl_tax: number;
total_excl_tax: number;
total_tax: number;
total_incl_tax: number;
is_free: boolean;
created_at: string;
updated_at: string;
variant?: VariantResource;
subscription_plan?: SubscriptionPlanResource;
cart_discounts?: Array<CartDiscountResource>;
};
export type CartResource = {
id: number;
label: string;
payment_type: PaymentTypeEnum | null;
is_tax_enabled: boolean;
is_b2b: boolean;
discounts_excl_tax: number;
discounts_tax: number;
discounts_incl_tax: number;
subtotal_excl_tax: number;
subtotal_tax: number;
subtotal_incl_tax: number;
carrier_tax_rate: number;
shipping_price_excl_tax: number;
shipping_price_tax: number;
shipping_price_incl_tax: number;
total_excl_tax: number;
total_tax: number;
total_incl_tax: number;
total_weight: number;
last_reminder_sent_at: string | null;
reminder_count: number;
created_at: string;
updated_at: string;
currency?: CurrencyResource;
customer?: CustomerResource;
carrier?: CarrierResource;
delivery_address?: AddressResource;
billing_address?: AddressResource;
order?: OrderResource;
cart_lines?: Array<CartLineResource>;
cart_lines_count?: number;
cart_discounts?: Array<CartDiscountResource>;
cart_only_discounts?: Array<CartDiscountResource>;
};
export type CartSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
has_order: number | null;
has_customer: number | null;
customer_id: number | null;
start_at: string | null;
end_at: string | null;
};
export type CartonCloudLogResource = {
id: number;
reference: string | null;
type: CartonCloudLogTypeEnum;
uuid: string | null;
status: string;
processed: boolean;
answer: Array<any>;
error: string | null;
backend_link?: string;
created_at: string;
updated_at: string;
};
export enum CartonCloudLogTypeEnum { OUTBOUND = 'OUTBOUND', STOCK_ON_HAND = 'STOCK_ON_HAND' };
export type CategoryAssemblyGuideResource = {
frontend_links?: Record<string, string>;
assembly_guide_posts?: Array<PostAssemblyGuideResource>;
assembly_guide_posts_count?: number;
id: number;
parent_id: number | null;
label: string;
name: string;
name_translations?: Record<string, string>;
summary: string | null;
summary_translations?: Record<string, string>;
description: string | null;
description_translations?: Record<string, string>;
recursive_slug: string;
slug: string;
slug_translations?: Record<string, string>;
depth: number;
order_column: number;
type: CategoryTypeEnum;
is_active: boolean;
created_at: string;
updated_at: string;
parent?: any;
children?: Array<any>;
medias?: Array<MediaResource>;
main_image?: MediaResource;
seo?: SeoResource;
pivot_categoryable?: CategoryableResource;
};
export type CategoryMagazineResource = {
frontend_links?: Record<string, string>;
magazine_posts?: Array<PostMagazineResource>;
magazine_posts_count?: number;
id: number;
parent_id: number | null;
label: string;
name: string;
name_translations?: Record<string, string>;
summary: string | null;
summary_translations?: Record<string, string>;
description: string | null;
description_translations?: Record<string, string>;
recursive_slug: string;
slug: string;
slug_translations?: Record<string, string>;
depth: number;
order_column: number;
type: CategoryTypeEnum;
is_active: boolean;
created_at: string;
updated_at: string;
parent?: any;
children?: Array<any>;
medias?: Array<MediaResource>;
main_image?: MediaResource;
seo?: SeoResource;
pivot_categoryable?: CategoryableResource;
};
export type CategoryProductResource = {
frontend_links?: Record<string, string>;
products?: Array<ProductResource>;
products_count?: number;
id: number;
parent_id: number | null;
label: string;
name: string;
name_translations?: Record<string, string>;
summary: string | null;
summary_translations?: Record<string, string>;
description: string | null;
description_translations?: Record<string, string>;
recursive_slug: string;
slug: string;
slug_translations?: Record<string, string>;
depth: number;
order_column: number;
type: CategoryTypeEnum;
is_active: boolean;
created_at: string;
updated_at: string;
parent?: any;
children?: Array<any>;
medias?: Array<MediaResource>;
main_image?: MediaResource;
seo?: SeoResource;
pivot_categoryable?: CategoryableResource;
};
export type CategorySearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
is_active: number | null;
};
export enum CategoryTypeEnum { PRODUCT = 'product', ASSEMBLY_GUIDE = 'assembly-guide', MAGAZINE = 'magazine' };
export type CategoryableResource = {
category_id: number;
categoryable_type: string;
categoryable_id: number;
order_column: number;
is_default: boolean;
created_at: string;
updated_at: string;
};
export type ContactResource = {
id: number;
customer_id: number | null;
label: string;
firstname: string;
lastname: string;
email: string;
subject: string;
message: string;
message_truncated: string;
processed: boolean;
created_at: string;
updated_at: string;
customer?: CustomerResource;
};
export type ContactSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
has_customer: number | null;
customer_id: number | null;
processed: number | null;
};
export type CountryResource = {
id: number;
label: string;
name: string;
name_translations?: Record<string, string>;
iso_code: string;
call_prefix: number | null;
is_tax_enabled: boolean;
is_default: boolean;
is_active: boolean;
created_at: string;
updated_at: string;
shipping_zone?: ShippingZoneResource;
country_states?: Array<CountryStateResource>;
country_states_count?: number;
taxes?: Array<TaxResource>;
pivot_country_tax?: CountryTaxResource;
};
export type CountrySearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
is_tax_enabled: number | null;
is_default: number | null;
is_active: number | null;
shipping_zone_id: number | null;
};
export type CountryStateResource = {
id: number;
country_id: number;
label: string;
name: string;
iso_code: string;
is_active: boolean;
created_at: string;
updated_at: string;
country?: CountryResource;
};
export type CountryStateSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
is_active: number | null;
};
export type CountryTaxResource = {
country_id: number;
tax_id: number;
rate: number;
created_at: string;
updated_at: string;
};
export type CreditCardResource = {
id: number;
label: string;
token: string;
card_brand: string;
card_number: string;
card_expiry_year: number;
card_expiry_month: number;
is_default: boolean;
is_expired: boolean;
payment_type: PaymentTypeEnum;
payment_type_label: string | null;
created_at: string;
updated_at: string;
subscriptions_count?: number;
};
export type CreditCardSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
payment_type: PaymentTypeEnum | null;
is_default: number | null;
};
export type CreditNoteLineResource = {
id: number;
credit_note_id: number;
invoice_line_id: number;
quantity: number;
price_excl_tax: number;
price_tax: number;
price_incl_tax: number;
total_excl_tax: number;
total_tax: number;
total_incl_tax: number;
created_at: string;
updated_at: string;
};
export enum CreditNoteReasonEnum { DEFINITIVE_RETURN = 0, RETURN_FOR_EXCHANGE = 1, COMMERCIAL_GESTURE = 2 };
export type CreditNoteResource = {
id: number;
number: string;
reason: CreditNoteReasonEnum;
reason_label: string;
subtotal_excl_tax: number;
subtotal_tax: number;
subtotal_incl_tax: number;
shipping_price_excl_tax: number;
shipping_price_tax: number;
shipping_price_incl_tax: number;
total_excl_tax: number;
total_tax: number;
total_incl_tax: number;
amount_refunded: number;
created_at: string;
updated_at: string;
invoice?: InvoiceResource;
credit_note_lines?: Array<InvoiceLineResource>;
};
export type CreditNoteSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
customer_id: number | null;
payment_type: PaymentTypeEnum | null;
reason: CreditNoteReasonEnum | null;
start_at: string | null;
end_at: string | null;
};
export type CurrencyResource = {
id: number;
name: string;
name_translations?: Record<string, string>;
conversion_rate: number;
iso_code: string;
symbol: string;
is_default: boolean;
is_active: boolean;
created_at: string;
updated_at: string;
};
export type CurrencySearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
is_default: number | null;
is_active: number | null;
};
export enum CustomerGroupEnum { B2C = 'Particuliers', B2B = 'Professionnels' };
export type CustomerGroupResource = {
id: number;
label: string;
name: string;
is_tax_enabled: boolean;
is_deleteable: boolean;
created_at: string;
updated_at: string;
customers_count?: number;
};
export type CustomerGroupSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
is_tax_enabled: number | null;
};
export type CustomerResource = {
id: number;
label: string;
gender: GenderEnum | null;
company: string | null;
vat_number: string | null;
eori_number: string | null;
firstname: string;
lastname: string;
email: string;
phone: string | null;
birthdate: string | null;
email_verified_at: string | null;
locale: string | null;
is_active: boolean;
created_at: string;
updated_at: string;
customer_group?: CustomerGroupResource;
default_address?: AddressResource;
addresses?: Array<AddressResource>;
addresses_count?: number;
default_credit_card?: CreditCardResource;
credit_cards?: Array<CreditCardResource>;
credit_cards_count?: number;
orders?: Array<OrderResource>;
valid_orders_count?: number;
valid_orders_sum_total_incl_tax_with_conversion?: number;
carts?: Array<CartResource>;
subscriptions?: Array<SubscriptionResource>;
subscriptions_count?: number;
notification_types?: Array<NotificationTypeResource>;
tags?: Array<TagResource>;
};
export type CustomerSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
is_active: number | null;
is_subscribed_newsletter: number | null;
customer_group_id: number | null;
billing_country_id: number | null;
};
export type DiscountResource = {
id: number;
label: string;
type: DiscountTypeEnum;
type_label: string | null;
name: string;
name_translations?: Record<string, string>;
code: string | null;
value_type: DiscountValueTypeEnum;
value: number | null;
start_at: string;
end_at: string;
is_active: boolean;
prerequisite_amount: number | null;
prerequisite_quantity: number | null;
usage_limit: number | null;
usage_limit_per_customer: number | null;
usage_count: number;
allocation_limit: number | null;
new_customers_only: boolean;
created_at: string;
updated_at: string;
manufacturers?: Array<ManufacturerResource>;
categories?: Array<CategoryProductResource>;
customers?: Array<CustomerResource>;
customer_groups?: Array<CustomerGroupResource>;
carriers?: Array<CarrierResource>;
countries?: Array<CountryResource>;
variants?: Array<VariantResource>;
};
export type DiscountSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
is_active: number | null;
type: DiscountTypeEnum | null;
};
export enum DiscountTypeEnum { PRODUCT_DISCOUNT = 0, ORDER_DISCOUNT = 1, BUY_X_GET_Y = 2, SHIPPING_DISCOUNT = 3 };
export enum DiscountValueTypeEnum { PERCENTAGE = 0, FIXED_AMOUNT = 1 };
export type DiscountVariantResource = {
discount_id: number;
variant_id: number;
type: DiscountVariantTypeEnum;
quantity: number;
created_at: string;
updated_at: string;
};
export enum DiscountVariantTypeEnum { REQUIREMENT = 0, DISCOUNT = 1 };
export enum EffitraceCarrierEnum { AUTRE_TRANSPORTEUR_COMMANDE = '2701', AUTRE_TRANSPORTEUR_COLIS = '2702', COURSIER_CLASSIQUE = '2715', CHRONOPOST_CLASSIC_EUROPE = '0434', CHRONOPOST_EXPRESS_INTER = '0435', LA_POSTE_COLISSIMO_EXPERT_I = '0302', LA_POSTE_COLISSIMO_ACCESS_F = '0305', LA_POSTE_COLISSIMO_DOMICILE_INTER_SANS_SIGNATURE = '0318', LA_POSTE_COLISSIMO_DOMICILE_INTER_AVEC_SIGNATURE = '0319', ENLEVEMENT_ENTREPOT_COMMANDE = '2201', UPS_EXPRESS = '0902', UPS_STANDARD = '0904', UPS_SAVER = '0905' };
export enum EffitraceLogTypeEnum { EDI_ORDER = 'edi_commandes', EDI_ORDER_STATE = 'edi_etat_des_commandes', EDI_ORDER_TRACKING = 'edi_suivi_expedition', EDI_SUPPLIER = 'edi_fournisseurs', EDI_STOCK = 'edi_stock', EDI_PRODUCT = 'edi_articles' };
export enum ExportTypeEnum { XLSX = 'xlsx', PDF = 'pdf' };
export type FeatureResource = {
id: number;
label: string;
name: string;
name_translations?: Record<string, string>;
order_column: number;
is_searchable: boolean;
created_at: string;
updated_at: string;
feature_values?: Array<FeatureValueResource>;
feature_values_count?: number;
};
export type FeatureSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
is_searchable: number | null;
};
export type FeatureValueProductResource = {
feature_value_id: number;
product_id: number;
value: string | null;
value_translations?: Record<string, string>;
order_column: number;
created_at: string;
updated_at: string;
};
export type FeatureValueResource = {
id: number;
feature_id: number;
label: string;
name: string;
name_translations?: Record<string, string>;
order_column: number;
created_at: string;
updated_at: string;
feature?: FeatureResource;
pivot?: FeatureValueProductResource;
};
export type FeatureValueSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
};
export enum GenderEnum { MAN = 0, WOMAN = 1 };
export type InvoiceLineResource = {
id: number;
invoice_id: number;
order_line_id: number;
created_at: string;
updated_at: string;
credit_note_lines_count?: number;
credit_note_lines_sum_quantity?: number;
};
export type InvoiceResource = {
id: number;
number: string;
tenant_name: string;
tenant_address1: string;
tenant_address2: string | null;
tenant_zipcode: string;
tenant_city: string;
tenant_country: string;
tenant_legal_information: string | null;
created_at: string;
updated_at: string;
order?: OrderResource;
invoice_lines?: Array<InvoiceLineResource>;
credit_notes?: Array<CreditNoteResource>;
credit_notes_sum_subtotal_incl_tax?: number;
credit_notes_sum_shipping_price_incl_tax?: number;
credit_notes_sum_total_incl_tax?: number;
credit_notes_sum_amount_refunded?: number;
};
export type InvoiceSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
customer_id: number | null;
status: OrderStatusEnum | null;
payment_type: PaymentTypeEnum | null;
is_prestashop: number | null;
start_at: string | null;
end_at: string | null;
};
export enum LinkTargetEnum { SELF = 0, BLANK = 1 };
export type ManufacturerResource = {
id: number;
label: string;
name: string;
description: string | null;
description_translations?: Record<string, string>;
slug: string;
is_active: boolean;
created_at: string;
updated_at: string;
medias?: Array<MediaResource>;
seo?: SeoResource;
};
export type ManufacturerSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
is_active: number | null;
};
export enum MediaCollectionTypeEnum { IMAGES = 'images', FILES = 'files' };
export type MediaResource = {
id: number;
model_type: string;
model_id: number;
url: string | null;
thumb_url: string | null;
medium_url: string | null;
large_url: string | null;
uuid: string | null;
collection_name: string;
name: string;
file_name: string;
mime_type: string | null;
disk: string;
conversions_disk: string | null;
size: number;
manipulations: Array<any>;
custom_properties: Array<any>;
title: string | null;
caption: string | null;
generated_conversions: Array<any>;
responsive_images: Array<any>;
order_column: number;
created_at: string;
updated_at: string;
};
export type MenuResource = {
id: number;
parent_id: number | null;
label: string;
name: string;
name_translations?: Record<string, string>;
url: string;
url_translations?: Record<string, string>;
depth: number;
order_column: number;
type: MenuTypeEnum;
type_label: string | null;
target: LinkTargetEnum;
is_active: boolean;
created_at: string;
updated_at: string;
parent?: MenuResource;
children?: Array<MenuResource>;
medias?: Array<MediaResource>;
};
export type MenuSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
is_active: number | null;
};
export enum MenuTypeEnum { HEADER = 0, FOOTER = 1 };
export enum ModelTypeEnum { PRODUCT = 'App\\Models\\Product', POST = 'App\\Models\\Post', SUBSCRIPTION_PLAN = 'App\\Models\\SubscriptionPlan' };
export enum NotificationTypeEnum { OFFERS = 1, NEWSLETTER = 2 };
export type NotificationTypeResource = {
id: number | null;
name: string;
value: number;
label: string;
email: string | null;
optin_at: string | null;
optout_at: string | null;
subscribed: boolean;
customer?: CustomerResource;
};
export type NotificationTypeSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
has_customer: number | null;
is_subscribed: number | null;
customer_id: number | null;
type: NotificationTypeEnum | null;
optin_at_min: string | null;
optin_at_max: string | null;
optout_at_min: string | null;
optout_at_max: string | null;
};
export type OptionResource = {
id: number;
label: string;
name: string;
name_translations?: Record<string, string>;
type: OptionTypeEnum | null;
order_column: number;
is_searchable: boolean;
created_at: string;
updated_at: string;
option_values?: Array<OptionValueResource>;
option_values_count?: number;
};
export type OptionSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
is_searchable: number | null;
};
export enum OptionTypeEnum { SELECT = 0, RADIO = 1, COLOR = 2 };
export type OptionValueResource = {
id: number;
option_id: number;
label: string;
name: string;
name_translations?: Record<string, string>;
color: string | null;
order_column: number;
created_at: string;
updated_at: string;
option?: OptionResource;
};
export type OptionValueSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
};
export type OrderAddressResource = {
id: number;
label: string;
type: OrderAddressTypeEnum;
address_type: AddressTypeEnum;
address_type_label: string | null;
company: string | null;
firstname: string;
lastname: string;
address1: string;
address2: string | null;
zipcode: string;
city: string;
phone: string | null;
country_id: number | null;
country_name: string;
country_iso_code: string;
country_state_id: number | null;
country_state_name: string | null;
country_state_iso_code: string | null;
created_at: string;
updated_at: string;
country?: CountryResource;
country_state?: CountryStateResource;
};
export enum OrderAddressTypeEnum { DELIVERY = 'delivery', BILLING = 'billing' };
export type OrderCarrierResource = {
id: number;
carrier_name: string;
tracking_url: string | null;
tracking_number: string | null;
wms_reference: string | null;
wms_provider: WmsProviderEnum | null;
total_weight: number;
created_at: string;
updated_at: string;
carrier?: CarrierResource;
};
export type OrderDiscountResource = {
id: number;
name: string;
type: DiscountTypeEnum;
code: string | null;
value_type: DiscountValueTypeEnum;
value: number;
amount_discounted_excl_tax: number;
amount_discounted_tax: number;
amount_discounted_incl_tax: number;
created_at: string;
updated_at: string;
order?: OrderResource;
order_line?: OrderLineResource;
discount?: DiscountResource;
};
export type OrderLineResource = {
id: number;
variant_id: number | null;
label: string;
name: string;
options_name: string | null;
subscription_collection_name: string | null;
subscription_type_name: string | null;
customization_text: string | null;
sku: string | null;
barcode: string | null;
mpn: string | null;
quantity: number;
weight: number | null;
cost: number | null;
price_excl_tax: number;
price_tax: number;
price_incl_tax: number;
tax_name: string;
tax_rate: number;
discounts_excl_tax: number;
discounts_tax: number;
discounts_incl_tax: number;
total_excl_tax: number;
total_tax: number;
total_incl_tax: number;
is_free: boolean;
created_at: string;
updated_at: string;
tax?: TaxResource;
variant?: VariantResource;
subscription_plan?: SubscriptionPlanResource;
order_discounts?: Array<OrderDiscountResource>;
invoice_line?: InvoiceLineResource;
};
export type OrderPaymentResource = {
id: number;
order_id: number | null;
payable_type: string;
payable_id: number | null;
payment_type: PaymentTypeEnum;
payment_type_label: string;
amount: number | null;
fee: number | null;
net: number | null;
currency_iso_code: string | null;
payment_reference: string | null;
additional_payment_reference: string | null;
payout_reference: string | null;
comment: string | null;
is_refund: boolean;
created_at: string;
updated_at: string;
admin?: AdminResource;
order?: OrderResource;
invoice?: InvoiceResource;
creditNote?: CreditNoteResource;
};
export type OrderPaymentSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
customer_id: number | null;
country_id: number | null;
subscription_collection_id: number | null;
tag_id: number | null;
has_payout: number | null;
is_anomaly: number | null;
is_prestashop: number | null;
payment_type: PaymentTypeEnum | null;
payable_type: string | null;
start_at: string | null;
end_at: string | null;
payable_start_at: string | null;
payable_end_at: string | null;
};
export type OrderResource = {
id: number;
label: string;
number: string;
customer_id: number | null;
customer_label: string;
customer_company: string | null;
customer_vat_number: string | null;
customer_eori_number: string | null;
customer_firstname: string;
customer_lastname: string;
customer_email: string;
customer_phone: string | null;
currency_name: string;
currency_iso_code: string;
currency_conversion_rate: number;
carrier_name: string;
carrier_tax_name: string;
carrier_tax_rate: number;
status: OrderStatusEnum;
status_label: string | null;
payment_type: PaymentTypeEnum;
payment_type_label: string | null;
discounts_excl_tax: number;
discounts_tax: number;
discounts_incl_tax: number;
subtotal_excl_tax: number;
subtotal_tax: number;
subtotal_incl_tax: number;
shipping_price_excl_tax: number;
shipping_price_tax: number;
shipping_price_incl_tax: number;
total_excl_tax: number;
total_tax: number;
total_incl_tax: number;
total_weight: number;
is_tax_enabled: boolean;
is_b2b: boolean;
is_prestashop: boolean;
locale: string;
admin_comment?: string;
customer_comment: string | null;
created_at: string;
updated_at: string;
delivery_address?: OrderAddressResource;
billing_address?: OrderAddressResource;
invoice?: InvoiceResource;
cart?: CartResource;
currency?: CurrencyResource;
admin?: AdminResource;
customer?: CustomerResource;
carrier?: CarrierResource;
order_discounts?: Array<OrderDiscountResource>;
order_only_discounts?: Array<OrderDiscountResource>;
subscriptions?: Array<SubscriptionResource>;
order_lines?: Array<OrderLineResource>;
order_carriers?: Array<OrderCarrierResource>;
order_payments?: Array<OrderPaymentResource>;
order_status_logs?: Array<OrderStatusLogResource>;
tags?: Array<TagResource>;
};
export type OrderSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
customer_id: number | null;
carrier_id: number | null;
variant_id: number | null;
country_id: number | null;
tag_id: number | null;
status: OrderStatusEnum | null;
payment_type: PaymentTypeEnum | null;
product_variant_type: ProductVariantTypeEnum | null;
start_at: string | null;
end_at: string | null;
is_renewal: number | null;
is_prestashop: number | null;
subscription_position: number | null;
};
export enum OrderStatusEnum { PAYMENT_ERROR = 0, PAYMENT_ACCEPTED = 1, IN_PROGRESS = 2, OUT_OF_STOCK = 3, SHIPPED = 4, DELIVERED = 5, PARTIALLY_REFUNDED = 6, REFUNDED = 7, CANCELED = 8, PENDING_PAYMENT = 9, OTHER = 10, PRE_ORDER = 11, PRE_ORDER_TO_SEND = 12 };
export type OrderStatusLogResource = {
id: number;
status: OrderStatusEnum;
status_label: string;
comment: string | null;
is_notifiable: boolean;
created_at: string;
updated_at: string;
admin?: AdminResource;
};
export enum PageLayoutEnum { HOMEPAGE = 0, FAQ = 1, CONTACT = 2, ABOUT = 3, SIMPLE = 4, COLLECTION = 5, PRODUCT = 6, ASSEMBLY_GUIDE = 7, MAGAZINE = 8, FULL_KIT = 9 };
export type PageResource = {
id: number;
name: string;
name_translations?: Record<string, string>;
content: string | null;
content_translations?: Record<string, string>;
slug: string;
slug_translations?: Record<string, string>;
frontend_links?: Record<string, string>;
is_active: boolean;
layout: PageLayoutEnum;
created_at: string;
updated_at: string;
sections?: Array<SectionResource>;
seo?: SeoResource;
};
export type PageSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
is_active: number | null;
};
export enum PaymentContextEnum { LYRA_REST = 'Lyra rest API', LYRA_FORM = 'Lyra form API', STRIPE_REST = 'Stripe rest API', PAYPAL_REST = 'PayPal rest API' };
export type PaymentLogResource = {
id: number;
context: PaymentContextEnum;
context_label: string | null;
order_id: string;
status: string;
amount: number;
currency: string;
ip_address: string | null;
answer: Array<any>;
error: string | null;
backend_link?: string;
created_at: string;
updated_at: string;
};
export enum PaymentTypeEnum { LYRA = 0, PAYPAL = 1, STRIPE = 2, LYRA_MULTI = 3, INGENICO = 4, OTHER = 5 };
export type PostAssemblyGuideResource = {
frontend_links?: Record<string, string>;
default_category_assembly_guide?: CategoryAssemblyGuideResource;
category_assembly_guides?: Array<CategoryAssemblyGuideResource>;
id: number;
label: string;
name: string;
name_translations?: Record<string, string>;
summary: string | null;
summary_translations?: Record<string, string>;
content: string | null;
content_translations?: Record<string, string>;
slug: string;
slug_translations?: Record<string, string>;
author: string | null;
type: PostTypeEnum;
is_active: boolean;
created_at: string;
updated_at: string;
sections?: Array<SectionResource>;
medias?: Array<MediaResource>;
main_image?: MediaResource;
seo?: SeoResource;
tags?: Array<TagResource>;
};
export type PostMagazineResource = {
frontend_links?: Record<string, string>;
default_category_magazine?: CategoryMagazineResource;
category_magazines?: Array<CategoryMagazineResource>;
id: number;
label: string;
name: string;
name_translations?: Record<string, string>;
summary: string | null;
summary_translations?: Record<string, string>;
content: string | null;
content_translations?: Record<string, string>;
slug: string;
slug_translations?: Record<string, string>;
author: string | null;
type: PostTypeEnum;
is_active: boolean;
created_at: string;
updated_at: string;
sections?: Array<SectionResource>;
medias?: Array<MediaResource>;
main_image?: MediaResource;
seo?: SeoResource;
tags?: Array<TagResource>;
};
export type PostSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
is_active: number | null;
default_category_assembly_guide_id: number | null;
default_category_magazine_id: number | null;
};
export enum PostTypeEnum { ASSEMBLY_GUIDE = 'assembly-guide', MAGAZINE = 'magazine' };
export type ProductResource = {
id: number;
label: string;
name: string;
name_translations?: Record<string, string>;
summary: string | null;
summary_translations?: Record<string, string>;
description: string | null;
description_translations?: Record<string, string>;
additional_information: string | null;
additional_information_translations?: Record<string, string>;
slug: string;
slug_translations?: Record<string, string>;
frontend_links?: Record<string, string>;
variant_type: ProductVariantTypeEnum;
is_active: boolean;
has_customization: boolean;
created_at: string;
updated_at: string;
default_variant?: VariantResource;
default_category_product?: CategoryProductResource;
category_products?: Array<CategoryProductResource>;
manufacturer?: ManufacturerResource;
variants?: Array<VariantResource>;
tags?: Array<TagResource>;
related_products?: Array<ProductResource>;
feature_values?: Array<FeatureValueResource>;
sections?: Array<SectionResource>;
medias?: Array<MediaResource>;
main_image?: MediaResource;
seo?: SeoResource;
pivot_categoryable?: CategoryableResource;
pivot_subscription_plan_product_issue?: SubscriptionPlanProductIssueResource;
pivot_subscription_plan_product_gift?: SubscriptionPlanProductGiftResource;
subscription_plans_as_issue?: Array<SubscriptionPlanResource>;
subscription_plans_as_issue_count?: number;
subscription_plans_as_gift?: Array<SubscriptionPlanResource>;
subscription_plans_as_gift_count?: number;
variants_count?: number;
variants_sum_quantity?: number;
variants_min_price_excl_tax?: number;
};
export type ProductSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
is_active: number | null;
default_category_product_id: number | null;
manufacturer_id: number | null;
variant_type: ProductVariantTypeEnum | null;
};
export enum ProductVariantTypeEnum { WITHOUT_OPTIONS = 0, WITH_OPTIONS = 1, FULL_KIT = 2 };
export type SectionResource = {
id: number;
default_type: BlockTypeEnum;
image?: string;
label: string;
is_editable: boolean;
max_blocks: number;
created_at: string;
updated_at: string;
blocks?: Array<BlockResource>;
};
export type SeoFormRequest = {
title: Array<any> | null;
description: Array<any> | null;
keywords: Array<any> | null;
};
export type SeoResource = {
id: number;
title: string | null;
title_translations?: Record<string, string>;
description: string | null;
description_translations?: Record<string, string>;
keywords: string | null;
keywords_translations?: Record<string, string>;
created_at: string;
updated_at: string;
};
export type ShippingLogResource = {
id: number;
wms_provider: WmsProviderEnum;
reference: string | null;
type: EffitraceLogTypeEnum | CartonCloudLogTypeEnum;
status: string;
processed: boolean;
answer: Array<any>;
error: string | null;
backend_link?: string;
created_at: string;
updated_at: string;
};
export type ShippingZoneResource = {
id: number;
label: string;
name: string;
is_active: boolean;
created_at: string;
updated_at: string;
pivot?: CarrierRangeShippingZoneResource;
};
export type ShippingZoneSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
is_active: number | null;
};
export type SubscriptionCollectionResource = {
id: number;
label: string;
name: string;
name_translations?: Record<string, string>;
description: string | null;
description_translations?: Record<string, string>;
slug: string;
slug_translations?: Record<string, string>;
frontend_links?: Record<string, string>;
order_column: number;
is_active: boolean;
created_at: string;
updated_at: string;
sections?: Array<SectionResource>;
medias?: Array<MediaResource>;
main_image?: MediaResource;
seo?: SeoResource;
subscription_plans?: Array<SubscriptionPlanResource>;
subscription_plans_count?: number;
subscriptions_count?: number;
};
export type SubscriptionCollectionSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
is_active: number | null;
};
export enum SubscriptionFrequencyEnum { MONTHLY = 1, FORTNIGHTLY = 2 };
export type SubscriptionOrderResource = {
subscription_id: number;
order_id: number;
subscription_position: number;
created_at: string;
updated_at: string;
};
export enum SubscriptionPaymentStatusEnum { REFUSED = 0, ACCEPTED = 1, EXPIRED = 2 };
export type SubscriptionPlanProductGiftResource = {
subscription_plan_id: number;
product_id: number;
order_column: number;
delivery_position: number | null;
is_purchasable: boolean;
created_at: string;
updated_at: string;
};
export type SubscriptionPlanProductIssueResource = {
subscription_plan_id: number;
product_id: number;
order_column: number;
subscription_position: number;
price_rule: SubscriptionPriceRuleEnum;
packing_and_postage: number | null;
is_purchasable: boolean;
is_subscribable: boolean;
is_renewable: boolean;
created_at: string;
updated_at: string;
};
export type SubscriptionPlanResource = {
id: number;
label: string;
price_incl_tax: number;
duration: number;
summary: string | null;
summary_translations?: Record<string, string>;
description: string | null;
description_translations?: Record<string, string>;
order_column: number;
is_active: boolean;
created_at: string;
updated_at: string;
subscription_type?: SubscriptionTypeResource;
subscription_collection?: SubscriptionCollectionResource;
product_issues?: Array<ProductResource>;
product_gifts?: Array<ProductResource>;
product_issues_count?: number;
product_gifts_count?: number;
subscriptions_count?: number;
pivot_subscription_plan_product_issue?: SubscriptionPlanProductIssueResource;
pivot_subscription_plan_product_gift?: SubscriptionPlanProductGiftResource;
};
export type SubscriptionPlanSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
is_active: number | null;
};
export enum SubscriptionPriceRuleEnum { SUBSCRIPTION = 0, PRODUCT = 1 };
export type SubscriptionResource = {
id: number;
label: string;
subscription_collection_name: string;
subscription_type_name: string;
currency_name: string;
currency_iso_code: string;
currency_conversion_rate: number;
carrier_name: string;
carrier_tax_name: string;
carrier_tax_rate: number;
current_position: number;
start_position: number;
duration: number;
quantity: number;
price_incl_tax: number;
shipping_price_incl_tax: number;
total_incl_tax: number;
frequency: SubscriptionFrequencyEnum;
frequency_label: string | null;
status: SubscriptionStatusEnum;
status_label: string | null;
payment_status: SubscriptionPaymentStatusEnum;
payment_status_label: string | null;
payment_type: PaymentTypeEnum;
payment_type_label: string | null;
start_at: string;
end_at: string;
renewal_at: string | null;
canceled_at: string | null;
is_prestashop: boolean;
admin_comment?: string;
created_at: string;
updated_at: string;
customer?: CustomerResource;
delivery_address?: AddressResource;
billing_address?: AddressResource;
credit_card?: CreditCardResource;
subscription_plan?: SubscriptionPlanResource;
currency?: CurrencyResource;
oldest_order?: OrderResource;
latest_order?: OrderResource;
starting_order_line?: OrderLineResource;
current_order_line?: OrderLineResource;
activities?: Array<ActivityResource>;
orders?: Array<OrderResource>;
tags?: Array<TagResource>;
pivot?: SubscriptionOrderResource;
};
export type SubscriptionSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
customer_id: number | null;
subscription_collection_id: number | null;
variant_id: number | null;
subscription_type_id: number | null;
tag_id: number | null;
frequency: SubscriptionFrequencyEnum | null;
status: SubscriptionStatusEnum | null;
payment_status: SubscriptionPaymentStatusEnum | null;
payment_type: PaymentTypeEnum | null;
start_at_min: string | null;
start_at_max: string | null;
end_at_min: string | null;
end_at_max: string | null;
renewal_at_min: string | null;
renewal_at_max: string | null;
is_prestashop: number | null;
};
export enum SubscriptionStatusEnum { CANCELED = 0, ACTIVE = 1, ENDED = 2 };
export type SubscriptionTypeResource = {
id: number;
label: string;
name: string;
name_translations?: Record<string, string>;
slug: string;
slug_translations?: Record<string, string>;
summary: string | null;
summary_translations?: Record<string, string>;
frequency: SubscriptionFrequencyEnum;
frequency_label: string | null;
order_column: number;
is_active: boolean;
created_at: string;
updated_at: string;
subscription_plans?: Array<SubscriptionPlanResource>;
subscription_plans_count?: number;
subscriptions_count?: number;
};
export type SubscriptionTypeSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
frequency: SubscriptionFrequencyEnum | null;
is_active: number | null;
};
export type TagResource = {
id: number;
label: string;
name: string;
name_translations?: Record<string, string>;
type: TagTypeEnum;
type_label: string | null;
created_at: string;
updated_at: string;
};
export type TagSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
type: TagTypeEnum | null;
};
export enum TagTypeEnum { PRODUCT = 'product', CUSTOMER = 'customer', ORDER = 'order', SUBSCRIPTION = 'subscription', POST = 'post', ADDRESS = 'address' };
export type TaxResource = {
id: number;
label: string;
name: string;
created_at: string;
updated_at: string;
countries?: Array<CountryResource>;
pivot_country_tax?: CountryTaxResource;
};
export type TaxSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
};
export type TenantResource = {
id: number;
name: string;
address1: string;
address2: string | null;
zipcode: string;
city: string;
country: string;
contact_email: string;
from_email: string;
facebook: string | null;
youtube: string | null;
instagram: string | null;
logo: string;
favicon: string;
primary_color: string;
secondary_color: string;
legal_information: string | null;
default_locale: string;
default_currency: string;
default_country: string;
locales_order: Array<any>;
cart_reminders: Array<any>;
sections?: Array<SectionResource>;
};
export enum TenantThemeEnum { AUSTRALIANCARS = 'australiancars', IXOCOLLECTIONS = 'ixocollections', RACINGBIKES = 'racingbikes' };
export type UserResource = {
id: number;
firstname: string;
lastname: string;
email: string;
};
export type VariantResource = {
id: number;
product_id: number;
label: string;
sku: string | null;
barcode: string | null;
mpn: string | null;
cost: number | null;
price_excl_tax: number;
price_incl_tax: number;
quantity: number;
reserved_quantity?: number;
minimal_quantity: number | null;
weight: number | null;
order_column: number;
is_active: boolean;
is_stock_enabled: boolean;
is_default: boolean;
is_preorder: boolean;
is_purchasable: boolean;
in_stock_infos: string | null;
in_stock_infos_translations?: Record<string, string>;
no_stock_infos: string | null;
no_stock_infos_translations?: Record<string, string>;
preorder_infos: string | null;
preorder_infos_translations?: Record<string, string>;
created_at: string;
updated_at: string;
tax?: TaxResource;
option_values?: Array<OptionValueResource>;
medias?: Array<MediaResource>;
main_image?: MediaResource;
product?: ProductResource;
variant_stock_logs?: Array<VariantStockLogResource>;
pivot_discount_variant?: DiscountVariantResource;
};
export type VariantSearchRequest = {
sort_column: string | null;
sort_direction: string | null;
search: string | null;
is_active: number | null;
is_default: number | null;
};
export type VariantStockLogResource = {
id: number;
label: string;
old_quantity: number;
new_quantity: number;
comment: string | null;
created_at: string;
updated_at: string;
admin?: AdminResource;
order?: OrderResource;
};
export enum WmsProviderEnum { CARTON_CLOUD = 'cartoncloud', EFFITRACE = 'effitrace' };
